import PropTypes from 'prop-types';
import React from 'react';
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { DashboardEdit } from "../../../assets/icons";
import { renderTableVacationsRealEstate } from "../dashboard-util/dashboard-utils";
import "./dashboard-real-estate.scss";
import "../../tasks/scenes/tasks-comments/shared-modal-header.scss";

const VacationModal = ({
  selectedMember,
  showState,
  onHideFunction
}) => {
  const hasVacationTracker = selectedMember?.VacationTracker && selectedMember?.VacationTracker.length > 0;

  const itemId = hasVacationTracker
    ? selectedMember?.VacationTracker[0]?.VacationsTaskId
    : null;

  const allowEdit = hasVacationTracker
    ? selectedMember?.VacationTracker[0]?.AllowVacationsEdit
    : false;

  const tableData = hasVacationTracker
    ? selectedMember?.VacationTracker[0]?.TableVacation
    : [];

  const itemName = hasVacationTracker
    ? selectedMember?.VacationTracker[0]?.VacationsTaskName
    : "";

  const keyRight = selectedMember.UserId ?? 0;
  const keyLeft  = selectedMember?.VacationTracker[0]?.ProjectId ?? 0;
  const keyMiddle = itemId ?? 0;

  const key = `${keyLeft}-${keyMiddle}-${keyRight}-${itemName}`;

  return (
    selectedMember && (
      <Modal
        key={key}
        show={showState}
        onHide={onHideFunction}
        contentClassName="deal-and-vacation-date-real-estate-modal-styles"
        dialogClassName="deal-and-vacation-date-real-estate-modal"
        backdropClassName="real-estate-modal-backdrop"
        scrollable={true}
      >
        <div className="popup-week real-estate-deal">
          <Modal.Header className="header-popup" closeButton>
              <div className="real-estate-deal-user-name">
                {selectedMember.Name}
                <div className="real-estate-deal-task-name">
                  Vacation Tracker
                </div>
              </div>
          </Modal.Header>
          <hr></hr>
          { allowEdit && (
            <div className="real-estate-edit-button-container">
              <div>
                <Link to={`/tasks/edit/std/${itemId}`} target="_blank" rel='noopener noreferrer'>
                  <div className="real-estate-edit">
                    <img alt="dropdown-arrow" src={DashboardEdit} />
                    {`${" "}Edit Table`}
                  </div>
                </Link>
              </div>
            </div>
          )}
          <Modal.Body className="header-body">
            { renderTableVacationsRealEstate(tableData) }
          </Modal.Body>
        </div>
      </Modal>
    )
  );
};

const ColumnPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  Name: PropTypes.string.isRequired,
  Type: PropTypes.string.isRequired,
  Order: PropTypes.number.isRequired,
  LookupValues: PropTypes.string,
  LockStatus: PropTypes.number.isRequired,
});

const DataPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  ColumnId: PropTypes.number.isRequired,
  ColumnType: PropTypes.string,
  ColumnName: PropTypes.string,
  Value: PropTypes.string,
  LookupValues: PropTypes.string,
  ColumnLockStatus: PropTypes.number,
});

const RowPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  Row: PropTypes.number.isRequired,
  Data: PropTypes.arrayOf(DataPropType),
});

const TablePropType = PropTypes.shape({
  Columns: PropTypes.arrayOf(ColumnPropType),
  Rows: PropTypes.arrayOf(RowPropType),
});

const BookedVacationPropType = PropTypes.shape({
  StartDate: PropTypes.string.isRequired,
  EndDate: PropTypes.string.isRequired,
  AdditionalComments: PropTypes.string.isRequired,
  Upcoming: PropTypes.bool.isRequired,
  BookedVacationString: PropTypes.string.isRequired,
  Color: PropTypes.string.isRequired,
  IsApproved: PropTypes.bool.isRequired,
  IsAwaitingApproval: PropTypes.bool.isRequired,
});


VacationModal.propTypes = {
  selectedMember: PropTypes.shape({
    CompanyId: PropTypes.number.isRequired,
    CompanyName: PropTypes.string.isRequired,
    UserId: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
    Type: PropTypes.string,
    TypeColor: PropTypes.string,
    ActiveDeals: PropTypes.number,
    LastUpdated: PropTypes.string,
    HoursThisWeek: PropTypes.number,
    WorkingWeekend: PropTypes.bool,
    HoursNextWeek: PropTypes.number,
    Comments: PropTypes.string,
    VacationTracker: PropTypes.arrayOf(PropTypes.shape({
      TaskId: PropTypes.number.isRequired,
      TaskName: PropTypes.string.isRequired,
      ProjectId: PropTypes.number.isRequired,
      ProjectName: PropTypes.string,
      OwnerUserId: PropTypes.number,
      OwnerUserName: PropTypes.string,
      EditorUserId: PropTypes.number.isRequired,
      EditorUserName: PropTypes.string.isRequired,
      Type: PropTypes.string,
      TypeColor: PropTypes.string,
      LastUpdated: PropTypes.string,
      VacationsTaskId: PropTypes.number.isRequired,
      VacationsTaskName: PropTypes.string.isRequired,
      VacationsProjectId: PropTypes.number.isRequired,
      AllowVacationsEdit: PropTypes.bool.isRequired,
      TableVacation: PropTypes.arrayOf(TablePropType),
      BookedVacations: PropTypes.arrayOf(BookedVacationPropType),
    })),
  }).isRequired,
  showState: PropTypes.bool.isRequired,
  onHideFunction: PropTypes.func.isRequired
};

export default VacationModal;
